import _ from "lodash";
import { useCallback } from "react";
import { useMappedState } from "redux-react-hook";

import { IProduct } from "src/core/products/api/products.api";
import { IStore } from "src/core/shared/store";

import { IOrderVariant } from "../api/orders.api";

/**
 * Custom hook to retrieve the order variant for a given product.
 *
 * This hook uses the product's `orderVariant` if available, or else finds the
 * variant from the global `orderVariants` list based on the `product.orderVariantId`.
 *
 * @param product - The product for which to retrieve the order variant.
 * @returns A function that provides the order variant associated with the given product.
 */

export const useProductOrderVariant = () => {
  const { orderVariants } = useMappedState((store: IStore) => ({ orderVariants: store.global.settings?.orderVariants || [] }));

  const getProductVariant = useCallback((product: IProduct) => {
    return (product.orderVariant ?? _.find(orderVariants, ov => ov.id === product.orderVariantId) ?? orderVariants[ 0 ]) as IOrderVariant;
  }, [ orderVariants ]);

  return getProductVariant;
};
